import { render, staticRenderFns } from "./choose-step-1.vue?vue&type=template&id=4b79c745&scoped=true&"
import script from "./choose-step-1.vue?vue&type=script&lang=js&"
export * from "./choose-step-1.vue?vue&type=script&lang=js&"
import style0 from "./choose-step-1.vue?vue&type=style&index=0&id=4b79c745&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b79c745",
  null
  
)

export default component.exports